import Cookies from 'js-cookie'
import {update_user} from './store/Store'
import API, {COOKIE_TOKEN_KW} from "./API";

export default class Session{

    static async tryLogin(username, password)
    {

        await API('hc', {});

        let rep = await API('login', {username, password});
        let ok = rep && rep.ok === true && rep.username === username;


        Cookies.set('_in', ok?'1':'0');
        Cookies.set('_defaultLogin', username);

        //if(ok) Session.sync();

        return ok;
    }

    static logout(){
        Cookies.remove('_in');
        Cookies.remove(COOKIE_TOKEN_KW);
    }

    static sync(){
        if(!Session.in())return false;
        let promise = API('whoami');
        promise.then(function(rep){
            update_user(rep.ok, rep.id, rep.username, rep.display_name);
        }).catch();
        return promise;
    }

    static in(){
        return Cookies.get('_in')=='1';
    }



}